import Vue from 'vue'
import Vuex from 'vuex'
import pay from './pay/index'
import rule from './rules/index'
import mall from './mall/index'
// // 调试工具 build时注释掉
// import createLogger from 'vuex/dist/logger'
// const debug = true

Vue.use(Vuex)
export default new Vuex.Store({
  modules: {
    pay,
    rule,
    mall
  }
  // strict: debug,
  // plugins: debug ? [createLogger()] : []
})



// WEBPACK FOOTER //
// ./src/stores/index.js